export default __webpack_public_path__ + "static/media/star.94147c24.png";